<template>
  <div class="fg-notification-wrap">
    <div class="bread">
      <router-link class="bread-item" to="/">上上签</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" to="/orders">订单管理</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" :to="'/orders/detail/'+user_order_id">订单详情</router-link>
      <div class="bread-arrow">&gt;</div>
      <a class="bread-item">赴馆通知书</a>
    </div>

    <div class="fg-wrap">
      <div class="fg-header">
        <div>赴馆通知书</div>
        <div class="buttons">
          <a class="download-interview" :href="pdfDownloadUrl ? pdfDownloadUrl : 'javascript:void(0);'" target="_blank"><span :class="pdfDownloadUrl ? 'loaded' : 'loading'"></span>下载赴馆通知书</a>
          <el-button type="default show-interview-video" v-if="DM.need_delivery === 0" @click="showVideo = true"><img src="../assets/imgs/play.png"> 面试培训视频</el-button>
          <el-button type="default show-interview-video show-share-btn" @click="wxShare"><img src="../assets/imgs/wechat.png"> 分享给顾客</el-button>
        </div>
      </div>

      <div class="fg-items interview-info">
        <div class="fg-title">
          <div class="fg-item-title-icon icon-interview-info"></div>
          赴馆信息
        </div>

        <div class="fg-item">
          <div class="fg-item-title">
            <div class="fg-item-label">赴馆人员：</div>
            <div class="fg-item-title-detail">
              {{applicantName}}
            </div>
          </div>
        </div>

        <div class="fg-item">
          <div class="fg-item-title">
            <div class="fg-item-label">赴馆时间：</div>
            <div class="fg-item-title-detail" style="color: #ff5a60; font-weight: 600;">
              {{idate}}
              <small>（请提前15分钟抵达）</small>
            </div>
          </div>
        </div>

        <div class="fg-item">
          <div class="fg-item-title">
            <div class="fg-item-label">领馆地址：</div>
            <div class="fg-item-title-detail">
              {{DM.embassy_address?DM.embassy_address.embassy_name:''}}
            </div>
          </div>
          <div class="fg-item-content" style="padding-left: 92px;">{{address}}</div>
        </div>

        <div class="fg-item" v-show="DM.companion_name">
          <div class="fg-item-title">
            <div class="fg-item-label">陪签人员：</div>
            <div class="fg-item-title-detail">
              {{DM.companion_name}}&nbsp;{{DM.companion_telephone}}
            </div>
          </div>
          <div class="fg-item-content"></div>
        </div>
      </div>

      <div class="fg-items">
        <div class="interview-material-box" v-if="isShowInterviewMaterial">
          <div class="material-item" v-if="DM.zip_photo_url">
            <div class="item-top">
              <!-- 证件照 -->
              <div style="width: 100px; height: 100px; position: relative; margin: 0 auto;">
                <div style="width: 90px;height: 90px; padding: 2px;display:block;border: 1px solid #eee;
                  position: absolute; left: 10px; bottom: 10px ;z-index: 1; background-color: white;"></div>
                <div style="width: 90px;height: 90px; padding: 2px;display:block;border: 1px solid #eee;
                  position: absolute; left: 5px; bottom: 5px; z-index: 2; background-color: white;"></div>
                <div style="width: 90px; height: 90px; padding: 2px; display:block; border: 1px solid #eee;
                  position: absolute; left: 0; bottom: 0; z-index: 3;
                  background: white no-repeat center center; background-size: cover;" :style="{ backgroundImage: `url(${DM.applicant_material[0].photo})` }"></div>
              </div>
            </div>
            <div class="item-bottom">
              <a class="download-btn" :href="DM.zip_photo_url" target="_blank">下载</a>
            </div>
          </div>
          <div class="material-item" v-for="(item,index) in DM.material_file_set" :key="index">
            <div class="item-top">
              <img class="item-icon" :src="getFileIcon(item.material_one)" alt="">
              <div class="item-name">{{item.name}}</div>
            </div>
            <div class="item-bottom">
              <a v-if="item.material_url" class="download-btn" :href="item.material_url" target="_blank" >下载</a>
              <!-- 电子申请表,没传文件 -->
              <div v-else>
                <span class="not-upload-tips">暂未上传，资料操作完毕后，您将收到上传提醒</span>
              </div>
            </div>
          </div>
        </div>
        <div class="interview-material-tips" v-if="isShowInterviewMaterial">{{materialTips}}</div>

        <div class="bottom-line"></div>
        <div class="fg-item fg-material">
          <div class="fg-item-title">
            <div class="fg-item-title-icon"></div>
            <div class="fg-item-title-detail">
              <div class="take">赴馆携带资料</div>
            </div>
          </div>
          <div class="fg-item-content">
            <div v-for="(appItem, index) in DM.interview" :key="index">
              <div class="app-name">
                <div class="app-name-applicant">{{appItem.applicant.join(',').replace(/,/g, '、')}}</div>
                <div class="app-name-identity">{{appItem.identity}}</div>
              </div>
              <div class="app-doc">
                <div class="app-doc-item">
                  <div class="material-tips">以下资料需要您自行准备携带至使馆现场</div>
                  <div class="materail-list-box">
                    <div class="material-item" v-for="preparedItem in appItem.material_prepared" :key="preparedItem.name">
                      <div class="materail-name">
                        {{preparedItem.take_along_name}}
                        <div class="material-prepare-box" v-if="DM.companion_name">
                          <div class="material-prepare">
                            自备
                          </div>
                        </div>
                      </div>
                      <div class="material-desc">{{preparedItem.attention}}</div>
                    </div>
                  </div>
                </div>

                <div class="app-doc-item" v-if="appItem.material_delivered && appItem.material_delivered.length">
                  <div class="material-tips">{{DM.companion_name ? '以下资料将由陪签员携带至使馆现场' : '您将收到以下邮寄资料，请携带至使馆现场'}}</div>
                  <div class="materail-list-box">
                    <div class="material-item" v-for="deliveredItem in appItem.material_delivered" :key="deliveredItem.name">
                      <div class="materail-name">
                        {{deliveredItem.take_along_name}}
                      </div>
                      <div class="material-desc">{{deliveredItem.attention}}</div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="bottom-line"></div>

        <!-- 面递订单存在 -->
        <div class="fg-item fg-tel-attention" v-if="DM.need_delivery > 0">
          <div class="fg-item-title">
            <div class="fg-item-title-icon"></div>
            <div class="fg-item-title-detail">
              <div class="fg-title2">电话调查注意事项</div>
            </div>
            <div class="warn-cue">
              电话调查是使馆核实申请人信息的常规方式，请按以下要求回答即可，不必惊慌
            </div>
          </div>
          <div class="fg-item-content">
            <ul>
              <li v-for="(item, index) in DM.tel_interview_notes" :key="index">{{item}}</li>
            </ul>
          </div>
        </div>
        <div class="bottom-line"></div>

        <div class="fg-item fg-attention">
          <div class="fg-item-title">
            <div :class="['fg-item-title-icon', {'fg-item-title-icon-finger': DM.need_interview === 0}]"></div>
            <div class="fg-item-title-detail">
              <div class="fg-title2">{{DM.need_interview > 0 ? ' 面试' : '录指纹'}}注意事项</div>
            </div>
          </div>
          <div class="fg-item-content">
            <ul>
              <li v-for="(attentionItem, index) in DM.interview_attention" :key="index">{{attentionItem}}</li>
            </ul>
          </div>
        </div>

        <div class="fg-item fg-proccess">
          <div class="fg-item-title">
            <div class="fg-item-title-icon"></div>
            <div class="fg-item-title-detail">
              <div class="fg-title2">{{DM.need_interview > 0 ? ' 面试' : '录指纹'}}流程</div>
            </div>
          </div>
          <div class="fg-item-content">
            <div class="processItem" v-for="(processItem, index) in DM.interview_process" :key="index">
              <div class="item-top">
                <span>{{index + 1}}</span>
                <span>{{processItem.title}}</span>
              </div>
              <div class="item-bottom">
                {{processItem.content}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <cant-view-orderDetail-modal v-model="cantViewShow" :cantViewShow="cantViewShow" :user_order_id="user_order_id"></cant-view-orderDetail-modal>

    <interview-video v-if="showVideo" @close="showVideo = false;" @share="wxShare"></interview-video>

    <wx-share :show="showShare" :order="DM" :names="applicantName" :url="shareUrl" @close="showShare = false"></wx-share>
  </div>
</template>

<script>
import wxUtils from '../libs/wx-utils';
import Http from '../libs/http';
import dateUtils from '../libs/date-util';
import addressUtils from '../libs/address-utils';
import pcdService from '../services/pcd-service';
import cantViewOrderDetailModal from '../components/order-detail/cant-view-order-detail-modal';
import interviewVideo from '../components/order-detail/interview-video';
import wxShare from '../components/order-detail/wx-share';
import countryService from '../services/country-service';

export default {
  data() {
    return {
      user_order_id: +this.$route.params.oid,
      order_applicant_id: +this.$route.params.aid,
      DM: {},
      idate: '',
      address: '',
      shareUrl: '',
      cantViewShow: false,
      applicantName: '',
      showVideo: false,
      showShare: false,
      telAttentionArray: [
        '出访目的：xxx前往法国旅游，请勿有其他商务目的',
        '机票信息请见下方机票预订单，建议熟悉出发时间及航班号',
        '具体行程安排请见附表，建议熟悉往返时间以及前往的城市和在各个城市的停留时间',
      ],
      // 赴馆通知书pdf下载地址
      pdfDownloadUrl: '',
    };
  },
  components: {
    cantViewOrderDetailModal,
    interviewVideo,
    wxShare,
  },
  computed: {
    // 获取赴馆通知书下载标题
    getDownloadInterviewTitle() {
      // 获取赴馆人数
      const length = this.DM.applicant_material
        ? this.DM.applicant_material.length
        : 0;
        // 赴馆人姓名数组
      const names = [];
      for (let i = 0; i < (length > 3 ? 3 : length); i++) {
        names[i] = this.DM.applicant_material[i].name;
      }
      return `${names.join('、') + (length > 3 ? '等' : '')}赴馆通知书`;
    },
    // 是否显示赴馆资料
    isShowInterviewMaterial() {
      if (!this.DM.country) return false;
      // 存在上传
      const haveUpload = this.DM.material_file_set.length;
      return haveUpload;
    },
    // 是否是美国面试
    isAmericaInterview() {
      if (!this.DM.country) return false;
      return this.DM.visa_country_id === countryService.getCountryId('america') && this.DM.need_interview;
    },
    // 是否事加拿大+需要面递申请表，需要禁用
    isCanadaApplication() {
      if (!this.DM.country) return false;
      return this.DM.visa_country_id && countryService.getCountryId('canada') && this.DM.need_ca_application;
    },
    // 资料的打印提示
    materialTips() {
      if (!this.DM.country) return;
      if (this.DM.companion_name) {
        // 陪签
        if (this.isAmericaInterview) {
          return '注：请查阅并核对上述资料，照片（尺寸为5*5cm）请自行携带，其他资料将由陪签员携带到签证中心，收到后请仔细核对。若您期间更改过预约时间，请查阅最新的邮件。';
        }
        return `注：请查阅并核对上述资料，资料将由陪签员携带到签证中心，收到后请仔细核对。若您期间更改过面签预约时间，请查阅最新的邮件信息。${
          this.isCanadaApplication ? '电子申请表请务必保存文件至U盘，和其他资料一起递交到使馆。' : ''
        }`;
      }
      // 不陪签
      if (this.isAmericaInterview) {
        return '注：以上资料需自行打印出来、携带赴馆，照片尺寸为5*5cm。若签证专家已邮寄资料，但您申请重新预约，请重新下载，并自行打印替换原资料。';
      }
      return `注：以上资料需自行打印出来、携带赴馆，若签证专家已邮寄资料，但您申请重新预约，请重新下载，并自行打印替换原资料。${
        this.isCanadaApplication ? '电子申请表请务必保存文件至U盘，和其他资料一起递交到使馆。' : ''
      }`;
    },
  },
  methods: {
    // 获取文件icon
    getFileIcon(url) {
      if (url.indexOf('.pdf') > -1) {
        return 'https://o.666visa.cn/static/ssqpeer/order/interview/icon-pdf.png';
      } else if (url.indexOf('.doc') > -1) {
        return 'https://o.666visa.cn/static/ssqpeer/order/interview/icon-word.png';
      } else if (url.indexOf('.xls') > -1) {
        return 'https://o.666visa.cn/static/ssqpeer/order/interview/icon-excel.png';
      }
      return 'https://o.666visa.cn/static/ssqpeer/order/interview/icon-image.png';
    },
    wxShare() {
      if (!this.shareUrl) {
        wxUtils
          .getQRCode(this.user_order_id, this.order_applicant_id)
          .then((data) => {
            this.shareUrl = data;
            this.showShare = true;
          }).catch((e) => {
            if (e) console.log(e);
          });
      } else {
        this.showShare = true;
      }
    },
    // 获取赴馆通知书pdf下载链接
    getNotificationPdf() {
      const self = this;
      // 声明请求地址, 默认为面试订单请求地址
      let reqUrl = '/applicant_interview_notify_download';
      // 赴馆时间
      const interview_time = new Date(this.DM.interview_time);
      // 赴馆携带资料
      const interview = this.DM.interview.map((item) => {
        const i = {};
        // 赴馆携带资料我方邮寄资料
        const material_required = item.material_delivered.map((mdItem) => {
          const mdi = {};
          mdi.take_along_name = mdItem.take_along_name;
          mdi.attention = mdItem.attention.split('\n');
          return mdi;
        });
        // 赴馆携带资料顾客自带资料
        const material_optional = item.material_prepared.map((moItem) => {
          const moi = {};
          moi.take_along_name = moItem.take_along_name;
          moi.attention = moItem.attention.split('\n');
          return moi;
        });
        i.applicant_names = item.applicant.join('、');
        i.identity = item.identity;
        i.material_required = material_required;
        i.material_optional = material_optional;
        return i;
      });
      // 请求参数
      const query = {
        applicant_names: this.applicantName,
        interview_date: dateUtils.getBaseDate(interview_time),
        interview_week: dateUtils.getWeekDay(interview_time),
        detail_time: dateUtils.getDateMinAndHour(interview_time),
        embassy_name: this.DM.embassy_address.embassy_name,
        full_address: this.address,
        companion_name: this.DM.companion_name,
        companion_telephone: this.DM.companion_telephone,
        interview,
        interview_attention: this.DM.interview_attention,
        interview_process: this.DM.interview_process,
        download_name: self.getDownloadInterviewTitle,
        peer_name: self.DM.peer_name,

      };
      // 如果不是面试则赋值为面递请求地址
      if (this.DM.need_delivery && this.DM.need_delivery > 0) {
        reqUrl = '/applicant_delivery_notify_download';
        query.tel_interview_notes = this.DM.tel_interview_notes;
      }
      Http.post(reqUrl, query).then((res) => {
        this.pdfDownloadUrl = res.pdf_url;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
  },
  created() {
    // 处理数据
    Http.post('/applicant_interview_query', {
      user_order_id: this.user_order_id,
      order_applicant_id: this.order_applicant_id,
    }).then((data) => {
      this.DM = data;

      // 若果时间变成 0000-00-00 00:00;即修改了赴馆时间转成等待预约的时候
      if (data.interview_time === '0000-00-00 00:00:00') {
        this.$router.push({
          name: 'orderDetail',
          params: { oid: this.user_order_id },
        });
      }

      // 转换名字
      const interview = this.DM.interview;
      let applicantArray = [];
      // 将所有申请人放到一起
      interview.forEach((val) => {
        applicantArray = applicantArray.concat(val.applicant);
      });
      this.applicantName = applicantArray.join('、');

      // 转换日期格式
      this.idate = `${dateUtils.dateChange(data.interview_time)} (GMT+8)`;

      // 获取pcds 和 地址
      pcdService.getPcd().then((pcdData) => {
        const pcds = pcdData;
        this.address = addressUtils.getAddress(pcds, {
          province_code: this.DM.embassy_address.province_code,
          city_code: this.DM.embassy_address.city_code,
          county_code: this.DM.embassy_address.county_code,
          detail_address: this.DM.embassy_address.detail_address,
        });
        this.getNotificationPdf();
      }).catch((e) => {
        if (e) console.log(e);
      });
    }).catch((e) => {
      if (e) console.log(e);
    });
  },
};
</script>
<style lang="less">
@import "../assets/less/base.less";
.fg-notification-wrap {
  .show-interview-video {
    margin-right: 20px;
    color: @main;
    border-color: @main;
    width: 134px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    height: 34px;
    padding: 0;
    margin-left: 0 !important;
    &:hover {
      opacity: 0.8;
    }
    span {
      display: flex;
      align-items: center;
      img {
        margin-right: 5px;
      }
    }
  }
  .show-share-btn {
    background-color: @main;
    color: #fff;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
<style lang="less" scoped>
@import "../assets/less/variable.less";

.fg-notification-wrap {
  width: 920px;
  margin: auto;
  padding-bottom: 56px;
  color: #444;
  .fg-wrap {
    .bottom-line{
      border-bottom: 1px dashed #e9e9e9;
      width: 920px;
      position: relative;
      right: 62px;

    }
    background-color: #fff;
    .fg-header {
      background-color: #fbfbfb;
      height: 70px;
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: space-between;
      @keyframes loading {
        0% {
          transform: rotate(0);
        }
        100% {
          transform: rotate(360deg);
        }
      }
      .loading {
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 100%;
        border: 1px solid @main;
        animation: loading 1.5s linear 2s infinite;
        position: relative;
        right: 5px;
        top: 3px;
        &::after {
          content: '';
          position: absolute;
          background-color: #eaf3ff;
          height: 7px;
          width: 7px;
          left: 2px;
          top: -2px;
        }
      }
      .loaded {
        position: relative;
        &::before {
          content: "";
          background: url("../assets/imgs/interview/download_interview.png")
            no-repeat;
          width: 15px;
          height: 15px;
          background-size: 100% 100%;
          position: absolute;
          left: -20px;
        }
      }
      .download-interview {
        font-size: 14px;
        color: #5e9be1;
        height: 14px;
        line-height: 14px;
        margin-right: 20px;
      }
      > div:nth-child(1) {
        margin-left: 20px;
        font-size: 18px;
        font-weight: 700;
        color: #333;
      }
      .buttons {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;

      }
    }

    .fg-items {
      padding: 0 46px 0 62px;
    }

    .icon-interview-info {
      background: url(../assets/imgs/interview/address.png);
    }

    .fg-title {
      display: flex;
      align-items: center;
      margin-top: 25px;
      margin-bottom: 5px;
      color: #333;
      font-weight: 600;
    }

    .fg-title2 {
      color: #333;
      font-weight: 600;
      font-size: 18px;
    }

    .fg-item-title-detail small {
      color: #aaa;
      font-size: 14px;
      font-weight: 400;
    }

    .fg-item-title-icon {
      width: 26px;
      height: 26px;
      margin-left: -40px;
      margin-right: 15px;
      background-size: 100% 100% !important;
    }

    .fg-item {
      padding: 16px 10px 20px 0px;
      font-size: 16px;
      .fg-item-title {
        display: flex;
        align-items: center;
      }
      .fg-item-content {
        margin-top: 10px;
        font-size: 14px;
        color: #777;
      }
    }
    .fg-tel-attention {
      padding-top: 30px !important;
      padding-bottom: 30px !important;
      .warn-cue {
        color: #ff5a60;
        font-size: 13px;
        position: relative;
        padding-left: 30px;
        &::before {
          content: "";
          position: absolute;
          left: 10px;
          background: url(../assets/imgs/interview/warn_cue.png) no-repeat;
          width: 14px;
          height: 14px;
          background-size: 100% 100%;
        }
      }
      .fg-item-title-icon {
        background: url(../assets/imgs/interview/tel_survey.png);
      }
      .fg-item-content {
        margin-top: 10px;
        ul {
          font-size: 14px;
          color: #777777;
          line-height: 24px;
          li {
            padding-left: 10px;
            position: relative;
            line-height: 24px;
          }
        }
        .download-content {
          display: flex;
          justify-content: space-between;
          padding: 0 36px;
          margin-top: 30px;
          .download-item {
            width: 226px;
            height: 210px;
            background-color: #fbfbfb;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            img {
              // margin-top: 20px;
              flex: none;
              width: 48px;
              height: 60px;
            }
            .title {
              font-size: 16px;
              margin-top: 20px;
              color: #333333;
            }
            .uploaded {
              margin-top: 10px;
              font-size: 12px;
              color: #aaaaaa;
            }
            .un-upload {
              font-size: 12px;
              line-height: 18px;
              color: #ff5a60;
              margin-top: 10px;
            }
            .download-btn {
              display: inline-block;
              margin-top: 20px;
              width: 120px;
              height: 32px;
              line-height: 32px;
              background-color: #3fa2f5;
              border-radius: 16px;
              color: #ffffff;
              border: 0;
            }
          }
        }
      }
    }
    .fg-item.fg-material {
      margin-top: 15px;
      padding-bottom: 15px;
      ul{
        margin: 0 !important;
        padding-left: 10px;
        position: relative;
      li{
        list-style: none;
      }
      }
      .app-doc{
      .material-item:nth-last-of-type(1){
        &::after{
          content:'';
          border: 0;
        }
      }
      }
      .fg-item-title-icon {
        background: url(../assets/imgs/interview/material.png);
      }
      .fg-item-title-detail {
        display: flex;
        flex: 1;
        align-items: center;

        .take {
          color: #333;
          font-weight: 600;
          font-size: 18px;
          position: relative;

        }
        .zbTips {
          color: #aaa;
          font-size: 13px;
          margin-left: 46px;
          margin-top: 2px;
        }
      }
      .fg-item-content {
        margin-top: 30px;

        .app-name {
          font-size: 16px;
          color: #444;
          font-weight: bold;
          position: relative;
          margin-bottom: 20px;
          .app-name-applicant{
            margin-right: 10px;
            display: inline;
            line-height: 24px;
          }
          .app-name-identity {
            display: inline-flex;
            align-items: center;
            color: #fff;
            font-size: 12px;
            line-height: 1;
            height: 18px;
            padding: 0 6px;
            border-radius: 9px;
            background: #CFCFCF;
            flex-shrink: 0;
            transform: translateY(-1px);
          }
        }
        .app-doc {
          .app-doc-item{
            margin-bottom: 40px;
            .material-tips{
              font-size: 14px;
              color: #5E9BE1;
              padding-bottom: 8px;
              border-bottom: 1px solid #F0F0F0;
            }
            .materail-list-box{
              .material-item{
                position: relative;
                padding: 20px 0;
                display: flex;
                align-items: center;
                &::after {
                  content: "";
                  display: block;
                  position: absolute;
                  border-bottom: 1px solid #f0f0f0;
                  left: 170px;
                  bottom: 0;
                  right: 0;
                }
                .materail-name{
                  flex-shrink: 0;
                  width: 130px;
                  margin-right: 42px;
                  font-size: 0;
                  line-height: 24px;
                  color: #38383E;
                  font-size: 16px;
                  word-break: break-all;
                  .material-prepare-box{
                    height: 24px;
                    display: inline-flex;
                    align-items: center;
                    .material-prepare{
                      font-size: 12px;
                      height: 18px;
                      border-radius:2px;
                      border:1px solid rgba(94,155,225,1);
                      color: #5E9BE1;
                      width:30px;
                      display: inline-flex;
                      align-items: center;
                      justify-content: center;
                      vertical-align: text-bottom;
                    }
                  }
                }
                .material-desc{
                  flex-grow: 1;
                  font-size: 14px;
                  color: #777;
                  line-height: 24px;
                  word-break: break-all;
                  white-space: pre-wrap;
                }
              }
            }
          }
        }
      }
    }
    .fg-item.fg-download {
      margin-top: 15px;

      .fg-item-title-icon {
        background: url(../assets/imgs/interview/download.png);
      }

      .download-tip {
        font-size: 12px;
        color: #ff5a60;
        line-height: 1.5;
      }
    }
    .fg-item.fg-attention {
      padding-bottom: 22px;
      padding-top: 30px !important;

      .fg-item-title-icon {
        background: url(../assets/imgs/interview/attention.png);
        &.fg-item-title-icon-finger {
          background: url(../assets/imgs/interview/get_finger.png);
        }
      }
      .fg-item-content {
        ul {
          margin-left: 18px;
          margin-top: 10px;
          li {
            color: #777777;
            line-height: 24px;
            font-size: 14px;
          }
        }
      }
    }
    .fg-item.fg-proccess {
      border-top: 1px solid #f0f0f0;
      padding-top: 30px;
      .fg-item-title-icon {
        background: url(../assets/imgs/interview/process.png);
      }
      .fg-item-content {
        padding-top: 10px;
        .processItem {
          position: relative;
          padding-bottom: 14px;
          &:before {
            content: "";
            position: absolute;
            border-left: 1px dotted #444;
            left: 10px;
            top: 20px;
            bottom: 0px;
          }
          .item-top {
            span:nth-child(1) {
              display: inline-block;
              width: 20px;
              height: 20px;
              line-height: 19px;
              border: 1px solid #444;
              border-radius: 50%;
              text-align: center;
              color: #444;
              font-size: 14px;
            }
            span:nth-child(2) {
              color: #333333;
              font-size: 16px;
              margin-left: 5px;
            }
          }
          .item-bottom {
            color: #aaaaaa;
            font-size: 14px;
            margin-left: 30px;
            line-height: 24px;
            margin-top: 8px;
          }
        }
        .processItem:last-of-type {
          &:before {
            content: "";
            border: none;
          }
        }
      }
    }

    .interview-material-box{
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      margin-right: -10px;
      margin-bottom: -10px;
      .material-item{
        width: 166px;
        height: 182px;
        background: #FBFBFB;
        border-radius: 4px;
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 20px 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .item-top{
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          .item-icon{
            width: 48px;
            height: 60px;
          }
          .item-name{
            margin-top: 10px;
            color: #333333;
            font-size: 16px;
            line-height: 22px;
            text-align: center;
          }
        }
        .item-bottom{
          flex-shrink: 0;
          .download-btn{
            width: 120px;
            height: 32px;
            background: #3FA2F5;
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 14px;
          }
          .not-upload-tips{
            font-size: 12px;
            line-height: 16px;
            color: #FF5A60;
          }
        }
      }
    }
    .interview-material-tips{
      padding: 18px 0 20px 0;
      color: #FF5A60;
      font-size: 14px;
      line-height: 24px;
    }
  }

  .interview-info {
    .fg-item-label {
      width: 92px;
    }

    .fg-item-title-detail {
      flex: 1;
    }

    .fg-item:nth-last-of-type(2){
      padding-bottom: 30px;
      &::after{
        content: '';
        border: 0;
      }
    }

    .fg-item {
      border: none;
      position: relative;
      padding: 18px 10px 15px 0px;

      &::after {
        content: "";
        border-bottom: 1px solid #f0f0f0;
        display: block;
        bottom: 0;
        position: absolute;
        left: 92px;
        right: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/InterviewNotification.vue